import { useEffect, useRef } from 'react';

/**
 * Hook to set a timeout
 * https://github.com/siddharthkp/use-timeout/blob/master/index.js
 *
 * @param callback - callback to be called after delay
 * @param delay - delay in ms
 */
export const useTimeout = (callback: () => void, delay: number) => {
  const savedCallback = useRef(() => {});

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setTimeout(tick, delay);
      return () => clearTimeout(id);
    }
  }, [delay]);
};
